import React from 'react';
import Components from '../components/components';
import ContentFilter from '../components/content-filter';
import HelmetSEO from '../components/seo';
import { getLocations, stripNode } from '../helpers/get-contents';

class ContactPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            location: '',
            tags: [],
            selectedTag: '',
            locations: stripNode(props.data.locations.edges),
            selectedLocation: '',
            allLocations: props.data.locations.edges.map(
                location => location.location
            ),
            traders: [],
        };
    }

    filterCallback = (name, event) => {
        const selected = event.target.value;
        let filteredTraders = stripNode(this.props.data.traders.edges);
        let filteredLocations = stripNode(this.props.data.locations.edges);
        let selectedTag = '';
        let selectedLocation = '';
        if (selected != '') {
            if (name == 'location') {
                selectedLocation = selected;
                filteredTraders = this.props.data.traders.edges.filter(
                    insight => {
                        return insight.location.location == selected;
                    }
                );
            }
        } else {
            filteredTraders = [];
        }
        this.setState({
            traders: filteredTraders,
            locations: filteredLocations,
            selectedTag: selectedTag,
            selectedLocation: selectedLocation,
        });
    };

    render() {
        let subpageLayout = false;

        let seo = {
            title: 'Contact us',
        };
        return (
            <div>
                <HelmetSEO {...seo} />
                <div
                    className={`contactpage section ${
                        subpageLayout == true ? 'indented-contents pt-60' : ''
                    }`}>
                    <Components
                        content={{
                            __typename: 'sidebysidetext',
                            title: 'Contact us',
                            body: '',
                        }}
                    />
                    <Components
                        content={{
                            __typename: 'DatoCmsContactOnLandingpage',
                            title: '',
                            people: [
                                this.props.data.peter,
                                this.props.data.kent,
                                this.props.data.steffen,
                            ],
                        }}
                        ignoreIndent={true}
                    />

                    <ContentFilter
                        defaultLocationText={'Choose supply location'}
                        callback={this.filterCallback}
                        tags={this.state.tags}
                        selectedTag={this.state.selectedTag}
                        locations={this.state.allLocations}
                        selectedLocation={this.state.selectedLocation}
                        showTag={false}
                    />
                    <Components
                        content={{
                            __typename: 'DatoCmsTradersLocationCollection',
                            traders: this.state.traders,
                            locations: this.state.locations,
                            selectedLocation: this.state.selectedLocation,
                        }}
                        ignoreIndent={true}
                    />
                </div>
            </div>
        );
    }
}

export default ContactPage;

export const SectionLandingPageQuery = graphql`
    query SectionLasdfndinerssdfssdfdfdsfssdfddffdsdfsdfssdffssdsdffsdfddsfsdffertrtegPageQsdfsduery1sfsdf1 {
        peter: datoCmsTrader(id: { eq: "DatoCmsTrader-156381-en" }) {
            ...TraderFragment
        }
        steffen: datoCmsTrader(id: { eq: "DatoCmsTrader-156383-en" }) {
            ...TraderFragment
        }
        kent: datoCmsTrader(
            id: { eq: "DatoCmsTrader-AWvSvZpFTqyvwd9BuUFDfg-en" }
        ) {
            ...TraderFragment
        }
        traders: allDatoCmsTrader(sort: { fields: [position], order: ASC }) {
            edges {
                node {
                    ...TraderFragment
                }
            }
        }
        locations: allDatoCmsLocation(
            filter: { root: { eq: true } }
            sort: { fields: [location], order: ASC }
        ) {
            edges {
                node {
                    location
                    address
                    phone
                    phoneAvailability
                    email
                    slug
                    region {
                        region
                    }
                    treeChildren {
                        location
                    }
                }
            }
        }
    }
`;

// date(formatString: "MMMM DD, YYYY")



// WEBPACK FOOTER //
// ./src/pages/contact.js